import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { pgiCalcItems } from '../models/pgiCalcItems';
import { ActivatedRoute } from '@angular/router';
import { CalcService } from '../shared/calc/calc.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { CoreService } from '../shared/core/core.service';
import { UserService } from '../shared/user/user-service.service';
import * as jspdf from 'jspdf';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DataService } from '../shared/data/data.service';

@Component({
  selector: 'app-calc-detail',
  templateUrl: './calc-detail.component.html',
  styleUrls: ['./calc-detail.component.css']
})
export class CalcDetailComponent implements OnInit {
  calcItem: pgiCalcItems[];
  selectedRowIndex = -1;
  userRole = [];
  displayedColumns = ['lp', 'twrCode', 'twrName', 'provisionPercent', 'quantity', 'salesValue', 'provisionValue', 'correction', 'notes'];
  dataSource: any;
  totalSumSalesValue: number;
  totalProvision: number;
  totalCorrection: number;
  stanKonta = 0;
  id = this.route.snapshot.paramMap.get('id');
  idPublished = false;
  authorName = '';
  zakres = '';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  btnSave = true;

  isLoading = false;
  isDisbale = true;
  color = 'primary';
  mode = 'indeterminate';
  typesprint = 0;

  constructor(public route: ActivatedRoute,
    public calcService: CalcService,
    public core: CoreService,
    private userService: UserService,
    public snackBar: MatSnackBar,
    public dataService: DataService) { }

  ngOnInit() {
    this.getDetailsCalculation();
  }

  getDetailsCalculation(): void {
    this.calcService.getDetailsCalculation(this.id).subscribe(
      calcItem => { this.calcItem = calcItem;

      this.dataSource = new MatTableDataSource();
      this.dataSource.data = calcItem;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.GetUserRole();
      this.totalSumSalesValue = this.dataSource.data.map(t => t.salesValue).reduce((acc, value) => acc + value, 0);
      this.totalCorrection = this.dataSource.data.map(t => t.correction).reduce((acc, value) => acc + value, 0);
      this.totalProvision = this.dataSource.data.map(t => t.provisionValue).reduce((acc, value) => acc + value, 0);
      this.getBalance(this.id);
      this.idPublished = calcItem[0].isPublished;
      this.authorName = calcItem[0].authorName;
      this.zakres = calcItem[0].zakres;
      }
    );
  }
  highlight(row) {
    this.selectedRowIndex = row.id;
  }

  goBack(): void {
    this.core.goBack();
  }

  checkRole(): void {
    const res = this.userRole.find(r => r === 'Administrator') != null;
    console.log(this.userRole);
    if (res) {
      this.isDisbale = false;
    } else {
      this.isDisbale = true;
    }
  }

  isRole() {
    // tslint:disable-next-line:max-line-length
    const res = this.userRole.find(c => c === 'Autor') != null;
    if (res) {
      this.displayedColumns = ['lp', 'twrCode', 'twrName', 'provisionPercent', 'provisionValue'];
      this.btnSave = false;
      }
  }

  GetUserRole() {
    this.userService.getUserClaimsRole().subscribe((data: any) => {
      this.userRole = data;
      this.isRole();
      this.checkRole();
      console.log(this.isDisbale);
    });
  }

  getTotalSalesValue() {
    const sum = this.dataSource.sum(t => t.salesValue);
    return sum;
  }
  getTotalProvision() {
    return this.dataSource.map(t => t.provisionValue).reduce((acc, value) => acc + value, 0);
  }
  getTotalCorrection() {
    return this.dataSource.map(t => t.correction).reduce((acc, value) => acc + value, 0);
  }
  print() {
    const res = this.userRole.find(c => c === 'Autor') != null;
    if (res) {
      this.typesprint = 4;
    } else {
      this.typesprint = 3;
    }
    this.dataService.getReportsCalculationsPdf(this.id, 0, this.typesprint)
      .subscribe(doc => {


         const file = new window.Blob([doc], { type: 'application/pdf' });
         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
          return;
         }
         const data = window.URL.createObjectURL(file);

         const link = document.createElement('a');
         link.href = data;
         link.download = 'naliczenie.pdf';
         // this is necessary as link.click() does not work on the latest firefox
         link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

         setTimeout(function () {
             // For Firefox it is necessary to delay revoking the ObjectURL
             window.URL.revokeObjectURL(data);
         }, 100);

      });
  }
  print2() {
    this.dataService.getReportsCalculationsPdf(this.id, 0, 4)
      .subscribe(doc => {


         const file = new window.Blob([doc], { type: 'application/pdf' });
         if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file);
          return;
         }
         const data = window.URL.createObjectURL(file);

         const link = document.createElement('a');
         link.href = data;
         link.download = 'naliczenie.pdf';
         // this is necessary as link.click() does not work on the latest firefox
         link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));

         setTimeout(function () {
             // For Firefox it is necessary to delay revoking the ObjectURL
             window.URL.revokeObjectURL(data);
         }, 100);

      });
  }
  /*print() {

    const fonts = {
      Roboto: {
        normal: 'fonts/Roboto-Regular.ttf',
        bold: 'fonts/Roboto-Medium.ttf'
      }
    };

    const title =  this.authorName + ' miesiac ' + this.zakres;
    const doc = new jspdf('landscape');

    let _columns = [];
    let _data = [ ];

    const header = function(data) {
      doc.setFontSize(14);
      doc.setTextColor(40);
      doc.setFontStyle(fonts);
      // doc.addImage(headerImgData, 'JPEG', data.settings.margin.left, 20, 50, 50);
      doc.text(title, data.settings.margin.left, 50);
    };

    const res = this.userRole.find(c => c === 'Autor') != null;
    if (res) {
      _columns = [
        {title: 'Indeks', key: 'twrCode'},
        {title: 'Nazwa', key: 'twrName'},
        {title: '%', key: 'provisionPercent'},
        {title: 'Naliczenie', key: 'provisionValue'}
    ];
    this.calcItem.forEach(x => {
      const item1 =  {'twrCode' : x.twrCode, 'twrName': x.twrName, 'provisionPercent': x.provisionPercent,
      'provisionValue': x.provisionValue};
      _data.push(item1);
    });

    doc.autoTable(_columns, _data, {
      addPageContent: header,
      margin: { top: 80},

      theme: 'grid',
      fontStyle: fonts,
      tableWidth: 'wrap',
      styles: {overflow: 'linebreak'},
      columnStyles: {
        'twrCode': {cellWidth: 25 },
        'twrName': {cellWidth: 220 },
        'provisionPercent': {cellWidth: 10 , fontStyle: 'bold', halign: 'right' },
        'provisionValue':  {cellWidth: 10 , fontStyle: 'bold', halign: 'right' },
      }
    });
    } else {
      _columns = [
        {title: 'twrCode', key: 'twrCode'},
        {title: 'Nazwa', key: 'twrName'},
        {title: '%', key: 'provisionPercent'},
        {title: 'Ilosc', key: 'quantity'},
        {title: 'Wartosc', key: 'salesValue'},
        {title: 'Naliczenie', key: 'provisionValue'},
        {title: 'Korekta', key: 'correction'},
        {title: 'Uwagi', key: 'notes'}
    ];
    this.calcItem.forEach(x => {
      const item1 =  {'twrCode' : x.twrCode, 'twrName': x.twrName, 'provisionPercent': x.provisionPercent,
      'quantity': x.quantity,  'salesValue': x.salesValue, 'provisionValue': x.provisionValue,
      'correction': x.correction, 'notes': x.notes};
      _data.push(item1);
    });

    doc.autoTable(_columns, _data, {
      addPageContent: header,
      margin: { top: 80},

      theme: 'grid',
      fontStyle: fonts,
      tableWidth: 'wrap',
      styles: {overflow: 'linebreak'},
      columnStyles: {
        'twrCode': {cellWidth: 25 },
        'twrName': {cellWidth: 100 },
        'provisionPercent': {cellWidth: 10 , fontStyle: 'bold', halign: 'right' },
        'quantity': {cellWidth: 10 , halign: 'right' },
        'salesValue': {cellWidth: 15 , halign: 'right' },
        'provisionValue':  {cellWidth: 10 , fontStyle: 'bold', halign: 'right' },
        'correction':  {cellWidth: 10 , halign: 'right' },
        'notes': {cellWidth: 50 }
      }
    });
    }




    // console.log(res.columns);
    doc.save('rozliczenie' + this.dataSource.data[0].month + '-' + this.dataSource.data[0].year + '.pdf');
  }
 */
  getBalance(id) {
    this.calcService.getBalance(id).subscribe(res => {
      this.stanKonta = res;
     });
  }

  refreshData() {

    this.totalCorrection = this.dataSource.data.map(t => t.correction).reduce((acc, value) => acc + value, 0);
    // tslint:disable-next-line:max-line-length
    this.totalProvision = this.dataSource.data.map(t => t.provisionValueOrginal).reduce((acc, value) => acc + value, 0) + this.totalCorrection ;
    this.RecalculateAccountBalanece(this.dataSource.data);
  }

  RecalculateAccountBalanece(data) {
    this.calcService.RecalculateBalance(data).subscribe(res => this.stanKonta = res);
  }

  saveChanges() {
    const publish = this.dataSource.data[0].isPublished;
    console.log(publish);
    if (publish) {
      this.openSnackBar('Naliczenie zostało już opublikowane - nie można wykonać zmian', '');
    } else {
    this.isLoading = true;

    this.dataSource.data.forEach(element => {
      element.isPublished = this.idPublished;
    });
    this.calcService.saveChanges(this.dataSource.data).subscribe(res => {
      this.isLoading = false;
    });
  }
  }

  generate() {
    const publish = this.dataSource.data[0].isPublished;
    console.log(publish);
    if (publish) {
      this.openSnackBar('Naliczenie zostało już opublikowane - nie można wykonać zmian', '');
    } else {
    this.isLoading = true;

    this.calcService.generate(this.dataSource.data).subscribe(res => {
      this.dataSource.data = res;
      this.totalSumSalesValue = this.dataSource.data.map(t => t.salesValue).reduce((acc, value) => acc + value, 0);
      this.totalCorrection = this.dataSource.data.map(t => t.correction).reduce((acc, value) => acc + value, 0);
      this.totalProvision = this.dataSource.data.map(t => t.provisionValue).reduce((acc, value) => acc + value, 0);
      this.getBalance(this.id);
      this.isLoading = false;
     });
  }
}

openSnackBar(message: string, action: string) {
  this.snackBar.open(message, action, {
    duration: 2000,
    verticalPosition: 'top',
  });
}
}
